var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.8499V20.4999C22 21.0303 21.7893 21.539 21.4142 21.9141C21.0391 22.2892 20.5304 22.4999 20 22.4999H4C3.46957 22.4999 2.96086 22.2892 2.58579 21.9141C2.21071 21.539 2 21.0303 2 20.4999V8.8499C2.00161 8.45104 2.12244 8.06178 2.34696 7.73212C2.57149 7.40247 2.88945 7.14747 3.26 6.9999L11.26 3.7999C11.7352 3.61065 12.2648 3.61065 12.74 3.7999L20.74 6.9999C21.1106 7.14747 21.4285 7.40247 21.653 7.73212C21.8776 8.06178 21.9984 8.45104 22 8.8499Z",
    stroke: "#3359E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5H18",
    stroke: "#3359E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.5H18",
    stroke: "#3359E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5H6V22.5H18V10.5Z",
    stroke: "#3359E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.090be21e2d1995520de6d396fc1f9452.svg";
export { ForwardRef as ReactComponent };